import { AppState } from 'services/types';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { SprayWaterRate } from 'services/sprayEvents/types';
import { OwnProps } from './index';
import { selectTotalArea } from '../../../../selectors';

const selectWaterRate = (state: AppState, props: OwnProps): SprayWaterRate =>
    props.waterRate;

const selectWaterTotal = createDeepEqualSelector(
    selectWaterRate,
    selectTotalArea,
    (waterRate, totalArea) => Number((waterRate * totalArea).toFixed(2))
);

const makeSelectWaterTotal = (): typeof selectWaterTotal => selectWaterTotal;

export { selectWaterRate, makeSelectWaterTotal };
